import { render } from "./Details.vue?vue&type=template&id=7302c7b6&scoped=true&ts=true"
import script from "./Details.vue?vue&type=script&lang=ts&setup=true"
export * from "./Details.vue?vue&type=script&lang=ts&setup=true"

import "./Details.vue?vue&type=style&index=0&id=7302c7b6&lang=scss&scoped=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7302c7b6"],['__file',"resources/js/Pages/Orchard/NutritionBalances/Details.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7302c7b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7302c7b6', __exports__)) {
    console.log('reload')
    api.reload('7302c7b6', __exports__)
  }
  
  module.hot.accept("./Details.vue?vue&type=template&id=7302c7b6&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('7302c7b6', render)
  })

}


export default __exports__